import apiClient from "./client";

export const createContactUsRequest = async (payload) => {
  const response = await apiClient.post("/contact-us", payload);
  return response.data;
};
